import React from 'react';
import { Spacer, HeaderContainer, HeaderContent, HighZindexSkipLink } from '../styles';

var HeaderShell = function HeaderShell(_ref) {
  var children = _ref.children,
      mainContentId = _ref.mainContentId,
      isResponsiveSearch = _ref.isResponsiveSearch,
      dataTest = _ref['data-test'];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HighZindexSkipLink, {
    mainContentId: mainContentId,
    showOnFocusOnly: true
  }, "Skip to main content"), /*#__PURE__*/React.createElement(HeaderContainer, {
    hideBorder: isResponsiveSearch,
    "data-test": "header-root-nav".concat(dataTest ? "-".concat(dataTest) : '')
  }, /*#__PURE__*/React.createElement(HeaderContent, {
    role: "banner"
  }, children)), /*#__PURE__*/React.createElement(Spacer, null));
};

HeaderShell.displayName = 'Header';
export default HeaderShell;